import { Injectable } from "@angular/core";
import { BaseService } from "./api-base.service";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs/Observable";
import { FilterCriteria } from "../models/filter-criteria";
import { UnapprovedRemittance } from "../models/unapproved-remittance.model";
import { ReconApiService } from "./recon-api.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class RemittanceUnapprovedService {
  private readonly timeout: number = 30000;
  private readonly basePath: string = "Remittance";

  constructor(
    private http: HttpClient,
    private apiBase: BaseService,
    private reconApiService: ReconApiService
  ) {}

  public async loadUnapprovedRemittances(
    clientId: string,
    criteria: FilterCriteria
  ) {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${
      this.basePath
    }/UnapprovedRemittances${criteria.toString()}`;
    let response = await this.http
      .get(url, { headers: this.apiBase.getHeaders() })
      .timeoutWith(
        this.timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
        this.reconApiService.logToElasticSearchFromUI(
          error,
          url
        );
      });
    return response;
  }

  public async requestApproval(
    clientId: string,
    remit: UnapprovedRemittance
  ): Promise<boolean> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/RequestApproval`;
    let response = await this.http
      .post(
        url,
        remit,
        { headers: this.apiBase.getHeaders() }
      )
      .timeoutWith(
        this.timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
        this.reconApiService.logToElasticSearchFromUI(
          error,
          url
        );
        if (error.status == 400) {
          toastr.error(JSON.parse(error._body)["Error"]);
        }
      });
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/remittance-unapproved.service.ts